import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuportOnlineComponent } from './suport-online.component';
import { MaterialModule } from 'src/app/material.module';
import { SolicitareComponent } from '../solicitare/solicitare.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [SuportOnlineComponent, SolicitareComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SuportOnlineModule { }